import { observer } from 'mobx-react';
import { registerStore } from 'stores';
import Store from '../store';

import Main from './Main';

registerStore('userStore', Store);

function Verify() {
  return <Main />;
}

export default observer(Verify);
